import { Component, OnInit } from '@angular/core';
import { event } from 'jquery';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, catchError, of } from 'rxjs';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';
//import { PopupDialogComponent } from '../../../popup-dialog/popup-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { IaproposalworkorderstatusComponent } from '../../iaproposalworkorderstatus/iaproposalworkorderstatus.component';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';

@Component({
  selector: 'app-iadashboard',
  templateUrl: './iadashboard.component.html',
  styleUrl: './iadashboard.component.css'
})

export class IadashboardComponent {
  totalproposal = 0;
  totalProposal = 0;  
  submittedProposal = 0;
  approvedProposal = 0;
  pendingProposal = 0;
  rejectedProposal = 0;
  totalEvents = 0
  completedEvents = 0;
  upcomingEvents = 0;
  //TotalRegisteredOnspot = 0;
  //TotalUnRegisterOnspot = 0;
  totalUnRegisteredOnspot = 0;
  totalRegisteredOnspot = 0;
  totalMSME = 0;
  
  
  length: number = 0;
  pageSize: number = 5;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  itemsPerPage: number = 10;
  isDisabled = true;

  TotalMSME = 0;
  TotalOnSpot = 0;
  
  totalGrievances = 0;
  disposedGrievances = 0;
  pendingGrievances = 0;
  rejectedGrievances = 0;
  userType: string | null = null;
  filePath: string = '';
  fileName: string = '';


  private manualFileMap = {
    MSME: {
      path: 'Images\\UserManual\\MSME\\RAMP-Portal-UserManul-For-V1-MSME.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-MSME.pdf'
    },
    IA: {
      path: 'Images\\UserManual\\IA\\RAMP-Portal-UserManul-For-V1-IA.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-IA.pdf'
    }
  };
    
  constructor(private dialog: MatDialog, private formBuilder: FormBuilder, private apiService: ApiService, private route: ActivatedRoute, private toastr: ToastrService, private router: Router,
    public commonService: CommonService) {

  }

  ngOnInit(): void {   
    this.LoadDetails(this.DtoPagination);
sessionStorage.setItem('status', 'Total');
    //This code is written for to show user manual
    this.route.paramMap.subscribe(params => {
      const menuId = params.get('id');
      //console.log('Came from menu with ID:', menuId);

      this.userType = sessionStorage.getItem('UserType')?.toUpperCase() || null;
      if (menuId === 'usermanual' && this.userType) {
        this.viewManual(this.userType as 'MSME' | 'IA');
      }
    });
  }

  viewManual(manualType: 'MSME' | 'IA') {
    const manual = this.manualFileMap[manualType];

    if (manual) {
      this.filePath = manual.path;
      this.fileName = manual.name;

      this.apiService.getFilePreview(this.filePath).subscribe({
        next: (fileUrl) => {
          const dialogRef = this.dialog.open(PreviewfileComponent, {
            width: '1200px',
            height: '80%',
            data: {
              fileUrl,
              fileName: this.fileName
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.router.navigate(['/iauserdashboard']);
          });
        },
        error: (err) => {
          console.error('Error loading file preview:', err);
        }
      });
    } else {
      console.warn('Manual not found for type:', manualType);
    }
  }

  CardRedirection(event: any) {
    //const buttonId = event.target.id;
    const buttonId = (event.currentTarget as HTMLElement).id;



let status = 'Total';

switch (buttonId) {
  case 'btnApprovedProposal':
    status = 'Approved';
    break;

  case 'btnPendingProposal':
    status = 'Pending';
    break;

  case 'btnRejectedProposal':
    status = 'Rejected';
    break;

  case 'btnTotalProposal':
    status = 'Total';
    break;

      default:
    status = 'Total';
    break;
}

sessionStorage.setItem('status', status);

console.log('buttonId:', buttonId);
console.log('status:', status);
console.log('typeof status:', typeof status);



    switch (buttonId) {
     
      case 'btnTotalProposal':
        this.commonService.searchText = '';
        this.router.navigate(['/iaproposalpage']);
        break;
      //case 'btnAllMSME':
      //  this.router.navigate(['/ia/msmeverification']);
        //  break;
       case 'btnAllMSME':
        this.router.navigate(['/viewregistermsmebyiainterest']);
        break;
        

      case 'btnRegOnSpot':
        this.commonService.searchText = 'reg';
        this.router.navigate(['/allonspotuserdetails']);
        break;
      case 'btnUnRegOnSpot':
        this.commonService.searchText = 'unreg';
        this.router.navigate(['/allonspotuserdetails']);
        break;
     
      case 'btnApprovedProposal':
        this.commonService.searchText = 'Approved';
        this.router.navigate(['/iaproposalpage']);
        break;
      case 'btnPendingProposal':
        this.commonService.searchText = 'Pending';
        this.router.navigate(['/iaproposalpage']);
        break;
      case 'btnRejectedProposal':
        this.commonService.searchText = 'Rejected';
        this.router.navigate(['/iaproposalpage']);
        break;
      case 'btnTotalEvents':
        this.commonService.searchText = '';
        this.router.navigate(['/view_event']);
        break;
      case 'btnCompletedEvents':
        this.commonService.searchText = 'completed';
        this.router.navigate(['/view_event']);
        break;
      case 'btnUpcomingEvents':
        this.commonService.searchText = 'created';
        this.router.navigate(['/view_event']);
        break;
      case 'btnTotalGrievances':
        this.commonService.searchText = '';
        this.router.navigate(['/iagrievanceDashboard']);
        break;
      case 'btnDisposedGrievances':
        this.commonService.searchText = 'Disposed';
        this.router.navigate(['/iagrievanceDashboard']);
        break;
      case 'btnPendingGrievances':
        this.commonService.searchText = 'Pending';
        this.router.navigate(['/iagrievanceDashboard']);
        break;
      case 'btnRejectedGrievances':
        this.commonService.searchText = 'Rejected';
        this.router.navigate(['/iagrievanceDashboard']);
        break;
      default:
        window.location.reload();
        break;
    }
  }

  DtoPagination =
    {
      "UserId": sessionStorage.getItem("iauserid"),
      "PageNumber": 1,
      "PageSize": 5,
      "SortColumn": "",
      "SortDirection": "DESC",
      "SearchTerm": ""
    }


  LoadDetails(DtoPagination: any) {
    this.pageSize = 5;
    this.apiService.getRequest(API_ENDPOINTS.IA.GETIAPROPOSALLIST, DtoPagination).subscribe(
      result => {
        if (result.status) {
          var summary = result.data.item1;
          //this.dataSource = result.data.item2;
          //this.length = summary["totalCount"];
          //this.totalproposal = summary["totalCount"];
          this.totalProposal = summary["totalCount"];
          this.pendingProposal = summary["pendingCount"];
          this.approvedProposal = summary["approvedCount"];
          this.rejectedProposal = summary["rejectedCount"];

          if (result.data.item3.length > 0) {
            //console.log(result.data.item3);
            const dialogRef = this.dialog.open(IaproposalworkorderstatusComponent, { data: result.data.item3 });
            dialogRef.afterClosed().subscribe(() => { });
          }
          
        }
      }
    )

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETIAEventList, DtoPagination).subscribe(
      result => {
        if (result.status) {
          var summary = result.data.item1;
          //this.dataSource = result.data.item2;
          //this.length = summary["totalCount"];

          this.totalEvents = summary["totalCount"];
          this.upcomingEvents = summary["pendingCount"];
          this.completedEvents = summary["approvedCount"];
          //this.rejectedEvent = summary["rejectedCount"];
        } else {
          this.toastr.error(result.message);
        }
      }
    )

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCECOUNTFORDASHBOARD).subscribe(
      result => {
        if (result.status) {
          this.totalGrievances = result.data.totalGrievances;
          this.disposedGrievances = result.data.disposedGrievances;
          this.pendingGrievances = result.data.pendingGrievances;
          this.rejectedGrievances = result.data.rejectedGrievances;
        }
      }
    )

    this.apiService.getRequest(API_ENDPOINTS.IA.GETTOTALMSMEREGISTERCOUNT).subscribe(
      result => {
        if (result.status) {
         // //console.log(result.data[0].TotalMSME);
         // this.totalRegisteredOnspot = result.data[0].TotalRegisteredOnspot;
         // console.log(this.TotalMSME);
         // this.totalUnRegisterOnspot = result.data[0].TotalUnRegisterOnspot;
          //console.log(this.TotalOnSpot);


          this.totalRegisteredOnspot = result.data[0].totalRegisteredOnspot;
          this.totalUnRegisteredOnspot = result.data[0].totalUnRegisterOnspot; // Corrected variable name
          this.totalMSME = result.data[0].totalMSME;

          //console.log(this.totalRegisteredOnspot); //
          //console.log(this.totalUnRegisteredOnspot);
          
        }
      }
    )
  }

}





